import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../../Api/firebase'
import { AllStarContext } from '../../../Context'
import { validateEmail } from '../../../Components/Auth/authHelpers'
import { checkCanSubmitToday } from '../../../Utils/AllStar/allStarHelper'
import { SaveBar } from '../styles'
import TextField from '../../../Components/LazyComponents/Inputs/TextField'

const useQuery = () => {
  return new URLSearchParams(window.location.search)
}

export const SaveCon: React.FC<React.PropsWithChildren<unknown>> = () => {
  let query = useQuery()
  const { email: em, login, isLoggedIn, authLoading } = useContext(AuthContext)!
  const { saveAllPicks } = useContext(AllStarContext)!
  const [email, setEmail] = useState<string>('')
  const [saving, setSaving] = useState<boolean>(false)
  const [locked, setLocked] = useState<boolean>(false)
  const [buttonText, setButtonText] = useState<string>('Submit Vote')
  const [errorMsg, setErrorMsg] = useState<string>('')
  const emailFromQuery = query.get('email')

  useEffect(() => {
    if (emailFromQuery) {
      setEmail(emailFromQuery)
      return
    }
    if (em) {
      setEmail(em)
      return
    }
    if (!checkCanSubmitToday()) {
      setLocked(true)
      setButtonText('Locked')
    }
  }, [])

  useEffect(() => {
    if (!saving && !checkCanSubmitToday()) {
      setLocked(true)
      setButtonText('Locked')
    }
  }, [saving])

  useEffect(() => {
    if (emailFromQuery) {
      setEmail(emailFromQuery)
      return
    }
    if (em) {
      setEmail(em)
    }
  }, [isLoggedIn, authLoading])

  const handleEmailChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setEmail(event.target.value)
  }

  const isButtonActive = () => {
    if (email.includes('@') && !saving && !locked) {
      return true
    } else {
      return false
    }
  }

  const onSave = async () => {
    if (saving) return
    setSaving(true)
    setButtonText('Saving...')
    const validated = validateEmail(email)
    if (!validated.errorMsg) {
      setErrorMsg('')
    } else {
      setErrorMsg(validated.errorMsg)
      setButtonText('Submit Vote')
      setSaving(false)
      return
    }
    try {
      let res = await saveAllPicks(email)
      if (!res) {
        setSaving(false)
        setButtonText('Submit Vote')
        return
      }
      setButtonText('Success!')
      setTimeout(() => {
        setSaving(false)
        setButtonText('Locked')
      }, 3000)
    } catch (e) {
      setSaving(false)
      setButtonText('Submit Vote')
    }
  }

  return (
    <SaveBar>
      <div className="submitCon">
        <TextField
          required
          inputMode="email"
          label="Email"
          variant="outlined"
          margin="none"
          id="email"
          size="small"
          style={{ minWidth: 290, fontSize: 10 }}
          value={email}
          onChange={(e) => {
            handleEmailChange(e)
          }}
        />
        <div className="error">{errorMsg}</div>
        {isButtonActive() && (
          <button className="mainBtn" onClick={() => onSave()}>
            {buttonText}
          </button>
        )}
        {!isButtonActive() && (
          <button className="loadingBtn" disabled>
            {buttonText}
          </button>
        )}
      </div>
      {!isLoggedIn && (
        <div className="subtextCon">
          <div className="subtext">{`Or `}</div>
          <button className="loginBtn" onClick={() => login()}>
            login
          </button>
          <div className="subtext">to get PLL Nation credit.</div>
        </div>
      )}
    </SaveBar>
  )
}
